<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <v-card>
      <v-overlay :value="prepare">
        <v-progress-circular
          indeterminate
          size="50"
        />
      </v-overlay>
      <v-form
        v-show="!prepare"
        id="form_role"
        ref="roleForm"
        v-model="isValid"
        lazy-validation
      >
        <v-card-title>
          <span
            v-if="!role.id"
            class="headline"
          >New Role</span>
          <span
            v-if="role.id"
            class="headline"
          >Update Role</span>
          <v-spacer />
          <v-btn
            icon
            @click="close()"
          >
            <v-icon color="error">
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-container class="px-0">
            <v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  id="role_name"
                  v-model="role.name"
                  append-icon="mdi-account-box"
                  name="role_Name"
                  :rules="nameRules"
                  label="Role Name*"
                  type="text"
                  autofocus
                  required
                  outlined
                  dense
                  :error-messages="getError('Name')"
                  @mouseup="dirtyError('Name')"
                />
              </v-col>
              <v-col cols="12">
                <v-expansion-panels
                  accordion
                  focusable
                >
                  <v-expansion-panel
                    v-for="item in privilegeGroups"
                    :key="`privilege-groups--${item.groupName}`"
                  >
                    <v-expansion-panel-header>
                      {{ item.groupName }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <!-- <v-divider /> -->
                      <v-switch
                        v-model="item.selectAll"
                        label="ALL"
                        color="primary"
                        hide-details
                        @change="
                          selectAllPrivilege(item.privileges, item.selectAll)
                        "
                      />
                      <v-switch
                        v-for="(subItem, index) in item.privileges"
                        :key="index"
                        v-model="privileges"
                        :label="`${subItem.label}`"
                        :value="subItem.code"
                        color="primary"
                        hide-details
                        @change="onChangePrivilege(item)"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <small> *indicates required field</small>
          <v-spacer />
          <v-btn
            id="close"
            color="error"
            class="white--text"
            style="position: relative"
            @click.native="close()"
          >
            Close
          </v-btn>

          <v-btn
            id="save"
            color="success"
            :disabled="!isValid"
            :loading="loader"
            @click.native="saveRole()"
          >
            {{ role.id ? "Update" : "Save" }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { failure } from "@/mixins/common";
export default {
  name: "RoleForm",
  mixins: [failure],
  props: {
    open: {
      type: Boolean
    },
    roleId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      prepare: false,
      loader: false,
      isValid: false,
      privilegeGroups: [],
      privileges: [],
      role: {},
      errors: {},
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 25) || "Name must be less than 25 characters"
      ]
    };
  },
  computed: {
    dialog: {
      get() {
        return this.open;
      },
      set(val) {
        this.$emit("update:open", val);
      }
    }
  },
  watch: {
    open: {
      immediate: true,
      handler(val) {
        if (val) {
          this.reset(true);
        }
      }
    }
  },
  methods: {
    getPrivilegeGroup() {
      let url = `${this.ADMIN_API_URL}/privilegeGroups`;
      this.$http.get(url).then((data) => {
        this.privilegeGroups = data.body;
        this.privilegeGroups.forEach((p) => {
          this.onChangePrivilege(p);
        });
      });
    },
    onChangePrivilege(feature) {
      feature.selectAll = true;
      feature.privileges.some((privilege) => {
        const idx = this.privileges.indexOf(privilege.code);
        if (idx < 0) {
          feature.selectAll = false;
          return true;
        }
      });
    },
    selectAllPrivilege(privileges, action) {
      privileges.forEach((privilege) => {
        var idx = this.privileges.indexOf(privilege.code);
        if (action && idx === -1) this.privileges.push(privilege.code);
        if (!action && idx > -1) this.privileges.splice(idx, 1);
      });
    },
    saveRole() {
      if (!this.$refs.roleForm.validate()) {
        return;
      }
      this.loader = true;
      let q;
      let url = `${this.ADMIN_API_URL}/roles`;
      this.role.privileges = this.privileges;
      if (this.role.id) {
        q = this.$http.put(`${url}/${this.role.id}`, this.role);
      } else {
        q = this.$http.post(url, this.role);
      }
      q.then(
        (resp) => {
          this.$store.commit("showSnackbar", {
            message: resp.body.message
          });
          this.$emit("refresh");
          this.close();
        },
        function (failure) {
          this.loader = false;
          this.errors = failure.body.errors;
          this.handleFailure(failure);
        }
      );
    },
    getRole: function (id) {
      if (!id) {
        this.prepare = false;
        return;
      }
      let url = `${this.ADMIN_API_URL}/roles/${id}`;
      this.$http.get(url).then(
        (resp) => {
          this.role = resp.body;
          this.privileges = this.role.privileges;
          this.prepare = false;
        },
        (failure) => {
          this.handleFailure(failure);
          this.close();
        }
      );
    },

    reset(init = false) {
      this.prepare = false;
      this.role = {};
      this.privileges = [];
      this.loader = false;
      this.isValid = true;
      this.errors = {};
      if (this.$refs.roleForm) {
        this.$refs.roleForm.reset();
      }
      if (init) {
        this.prepare = true;
        this.getPrivilegeGroup();
        this.$nextTick(() => {
          this.getRole(this.roleId);
        });
      }
    },
    close() {
      this.$emit("update:open", false);
      this.reset();
    },
    getError(key) {
      return this.errors && this.errors[key] ? [this.errors[key]] : [];
    },
    dirtyError(key) {
      this.errors[key] = "";
    }
  }
};
</script>